import { render, staticRenderFns } from "./Calories.vue?vue&type=template&id=01f41b31"
import script from "./Calories.vue?vue&type=script&lang=js"
export * from "./Calories.vue?vue&type=script&lang=js"
import style0 from "./Calories.vue?vue&type=style&index=0&id=01f41b31&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports